import { jsx as o } from "react/jsx-runtime";
import { O as s, Q as m } from "../../../vendor--aJiswR_.js";
import "react";
import "../../../theme/spacing.js";
import { omitStyleRenderProps as f } from "../../../utils/omitStyleRenderProps/index.js";
import '../../../assets/index37.css';const l = "_content_10ll5_1", b = "_popover_10ll5_17", t = {
  content: l,
  popover: b
};
function v({
  isOpen: e,
  onOpenChange: r,
  triggerRef: n,
  placement: c,
  ...p
}) {
  return /* @__PURE__ */ o(
    s,
    {
      isOpen: e,
      onOpenChange: r,
      triggerRef: n,
      className: t.popover,
      offset: 8,
      placement: c,
      children: /* @__PURE__ */ o(m, { ...f(p), className: t.content, slot: "menu" })
    }
  );
}
export {
  v as Content
};
//# sourceMappingURL=index.js.map
